<div
  class="team-info"
  *ngIf="team(); else noTeam"
  [nbPopover]="popover"
  [nbPopoverTrigger]="'hover'"
  [nbPopoverPlacement]="'bottom'"
  [ngStyle]="{color: team()?.color}">
  {{team()?.name}}
</div>

<ng-template #noTeam>
  <div class="no-team"></div>
</ng-template>

<ng-template #popover>
  <wr-team-popover [teamId]="team()?.id" [disableLink]="disableLink"></wr-team-popover>
</ng-template>
